import axios from '../utils/axios';

export default function downloadRelevantCourseEnquiry(adminId,courseId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course/' + courseId + '/relevant-leads/download',  {
            responseType: 'arraybuffer',
            params} )
    )
}